import React, { useState } from 'react'
import { useAddNewReport } from './addNewReport'
import HandleAnyPopupMessage from '../../Components/handleAnyPopupMessage'
import { FoundationsConstants } from '../../FoundationsConstants'

declare let window: any

interface EmptyWorkspaceProps {
    wsid: string
    WorkspaceId: string
    showAddWorkspaceReport: boolean
    showAttachReportOption:boolean
    showAttachExistingVisualUnitDialog: () => Promise<any>
}
const EmptyWorkspace: React.FC<EmptyWorkspaceProps> = ({
    wsid,
    WorkspaceId,
    showAddWorkspaceReport,
    showAttachReportOption,
    showAttachExistingVisualUnitDialog
}) => {
    const isShowAddWorkspaceReport =
        wsid !== 'Favorites' && wsid !== 'KMIs' && showAddWorkspaceReport
    const isShowAttachWorkspaceReport =
        wsid !== 'Favorites' && wsid !== 'KMIs' && showAttachReportOption
  const [showExportPopup, setShowExportPopup] = useState(false);

    const clickShowAttachDialog = () => {
        showAttachExistingVisualUnitDialog()
    }
    const { clickAddNewReport } = useAddNewReport({ WorkspaceId,setShowExportPopup  })
    return (
        <div>
            <div className="padding-top-large">No reports are present in this workspace.</div>
            <div className="padding-top-medium"></div>

            {(isShowAddWorkspaceReport || isShowAttachWorkspaceReport) && (
<div className="padding-bottom-large">
        You can{' '}
        {isShowAddWorkspaceReport && (

<a href="javascript:void(0);" onClick={clickAddNewReport}>
                    add a new report
</a>              

        )}
        {isShowAttachWorkspaceReport && isShowAddWorkspaceReport && ' or '}
        {isShowAttachWorkspaceReport && (
<a href="javascript:void(0);" onClick={clickShowAttachDialog}>
                attach an existing report
</a>
        )}
        {' '}to this workspace.
</div>
)}
  <HandleAnyPopupMessage
          isOpen={showExportPopup}
          title="Add new report"
          message={`Sorry, creating ${FoundationsConstants.enumVULabel.SingularLower} operation failed.`}
          onClose={() => setShowExportPopup(false)}
          Link={null}
          linkText=""
          textClasses = "ajax-page-error"
        />
        </div>
    )
}

export default EmptyWorkspace
